import {NOW} from './reference'

/**
 * The module's clock, in one place.
 *
 * Every deadline countdown, "last N days" range, weekly bucket and locally
 * stamped transition used to read `NOW` from data/reference.js directly — the
 * pinned instant the frozen demo dataset was generated against. That is right
 * for the seeded harness and for every unit test (they stay deterministic), and
 * wrong the moment the module runs against the real backend: a discrepancy due
 * on 20 Sep 2026 read "39 days left" in September because the clock was still
 * 7 Aug.
 *
 * So the pin is a MODE, not a constant. The default stays pinned (tests and the
 * harness never call anything here and behave exactly as before); index.js
 * unpins it for a live mount (unpinClock), and every consumer asks `nowMs()`
 * instead of touching NOW.
 */
let pinned = NOW

/**
 * Live mode: the wall clock. Called by index.js when it mounts without seeded rows.
 * (Not named use…: it is a plain function, not a React hook, and the hooks lint rule
 * keys on the prefix.)
 */
export function unpinClock() {
  pinned = null
}

/** Seeded mode / tests: pin the clock (defaults to the dataset's NOW). */
export function pinClock(date = NOW) {
  pinned = date
}

export function isClockPinned() {
  return pinned != null
}

export function nowMs() {
  return pinned ? pinned.getTime() : Date.now()
}

export function nowDate() {
  return new Date(nowMs())
}
